<ng-container *ngTemplateOutlet="isMobile ? clickTooltip : hoverTooltip"></ng-container>

<ng-template #tooltipContent>
  <span
    class="tooltip__info"
    [style.font-size]="fontSize"
    [style.color]="bulletTextColor"
  >
    <ng-container *ngIf="bulletIconName; else infoLetter">
      <mm-icon class="tooltip__icon" [isCurrentColor]="false" [name]="bulletIconName"></mm-icon>
    </ng-container>
    <ng-template #infoLetter>i</ng-template>
  </span>
  <div
    *ngIf="isVisible"
    class="tooltip__overlay-white"
    [style.background-color]="tooltipBackgroundColor"
    [ngClass]="{
      'tooltip__overlay-white__left': position === positions.bottomLeft,
      'tooltip__overlay-white__right': position === positions.bottomRight
    }"
  >
    <ng-content></ng-content>
  </div>
</ng-template>

<ng-template #hoverTooltip>
  <div
    class="tooltip-wrapper"
    (mouseenter)="showTooltip(); triggerHoverEvent()"
    (mouseleave)="hideTooltip()"
  >
    <p [ngStyle]="{ color: isVisible ? textHoverColor : textColor }">{{ customText || 'SHARED.SPONSORED.LABEL.TEXT' | translate }}</p>
    <div
      class="tooltip"
      [ngClass]="{'custom-icon': bulletIconName}"
      [style.width]="width+'px'"
      [style.height]="height+'px'"
      [style.color]="tooltipTextColor"
      [style.background-color]="isVisible ? customTooltipHoverBackgroundColor : bulletBackgroundColor"
    >
      <ng-container *ngTemplateOutlet="tooltipContent"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #clickTooltip>
  <button
    type="button"
    class="tooltip-wrapper tooltip-wrapper__button"
    (click)="triggerClickEvent()"
  >
    <p [ngStyle]="{ color: isVisible ? textHoverColor : textColor }">{{ customText || 'SHARED.SPONSORED.LABEL.TEXT' | translate }}</p>
    <div
      class="tooltip"
      [ngClass]="{'custom-icon': bulletIconName}"
      [style.width]="width+'px'"
      [style.height]="height+'px'"
      [style.color]="tooltipTextColor"
      [style.background-color]="isVisible ? customTooltipHoverBackgroundColor : bulletBackgroundColor"
    >
      <ng-container *ngTemplateOutlet="tooltipContent"></ng-container>
    </div>
  </button>
</ng-template>
